import { c as _c } from "react/compiler-runtime";
import { useSearchPageContext } from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/SearchPageContext';
import TagPillCount from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/TagPillCount';
import TagPill from '@/app/[locale]/(worlds)/components/TagPill';
import { SearchResultTab } from '@/lib/search';
import { useTranslations } from 'next-intl';
type SearchFilterTagsProps = {
  activeTab: string;
  setActiveTab: (tab: SearchResultTab) => void;
};
const tabLabels: Record<SearchResultTab, string> = {
  top: 'worlds-landing.search.tabs.top',
  games: 'worlds-landing.search.tabs.games',
  experiences: 'worlds-landing.search.tabs.experiences',
  videos: 'media-browser.nav_title.videos',
  creators: 'worlds-landing.search.tabs.creators'
};
export default function SearchFilterTags(t0) {
  const $ = _c(10);
  const {
    activeTab,
    setActiveTab
  } = t0;
  const {
    gamesTotal,
    experiencesTotal,
    accountsTotal,
    videosTotal
  } = useSearchPageContext();
  const t = useTranslations();
  let t1;
  if ($[0] !== accountsTotal || $[1] !== experiencesTotal || $[2] !== gamesTotal || $[3] !== videosTotal) {
    const tabCounts = {
      top: 0,
      games: gamesTotal,
      experiences: experiencesTotal,
      videos: videosTotal,
      creators: accountsTotal
    };
    t1 = Object.entries(tabCounts);
    $[0] = accountsTotal;
    $[1] = experiencesTotal;
    $[2] = gamesTotal;
    $[3] = videosTotal;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== activeTab || $[6] !== setActiveTab || $[7] !== t || $[8] !== t1) {
    t2 = t1.map(t3 => {
      const [tab, count] = t3;
      if (tab !== "top" && count === 0) {
        return null;
      }
      return <TagPill key={tab} label={t(tabLabels[tab as SearchResultTab])} isActive={activeTab === tab} onClick={() => setActiveTab(tab as SearchResultTab)} trailingContent={count > 0 ? <TagPillCount count={count} isActive={activeTab === tab} /> : undefined} />;
    });
    $[5] = activeTab;
    $[6] = setActiveTab;
    $[7] = t;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}